import Button from '../Button/Button';
import { ButtonSize, ButtonType, ShowIcon } from '../Button/consts';
import { ClickableAction } from '../Clickable/consts';
import Icon from '../Icon/Icon';
import StageBox from '../StageBox/StageBox';
import StageBoxInfo from '../StageBoxInfo/StageBoxInfo';
import styles from './CourseStageBox.module.scss';
import type { CourseStageBoxProps } from './types';

const CourseStageBox = ({
  title,
  category,
  durationInfo,
  euroPrice,
  location,
  anchorID,
}: CourseStageBoxProps) => {
  return (
    <StageBox
      backgroundType="white"
      hasShadow
      hasTopLine
      hasMobileBottomSkew={false}
      hasMobileShadow={false}
    >
      <div className={styles.base}>
        <div>
          <hgroup className={styles.headlines}>
            <h2 className={styles.subHeadline}>{category}</h2>
            <h1 className={styles.headline}>{title}</h1>
          </hgroup>

          <StageBoxInfo>
            <a
              href={`https://www.google.com/maps/search/${location}`}
              target="_blank"
              rel="noreferrer"
            >
              <span className="visually-hidden">
                {location} bei Google Maps anzeigen
              </span>
              <Icon size="iconSize24" variant="user/pin" aria-hidden="true" />
            </a>
            <span>{location}</span>
          </StageBoxInfo>

          <StageBoxInfo>
            <Icon size="iconSize24" variant="user/clock" />
            <span>{durationInfo}</span>
          </StageBoxInfo>

          <StageBoxInfo>
            <Icon size="iconSize24" variant="user/euro-symbol" />
            <span>{euroPrice}</span>
          </StageBoxInfo>
        </div>

        <Button
          className={styles.button}
          actionType={ClickableAction.Anchor}
          anchor={anchorID}
          icon="user/calendar"
          showIcon={ShowIcon.ShowIcon}
          size={ButtonSize.Medium}
          type={ButtonType.Button}
        >
          Jetzt anmelden
        </Button>
      </div>
    </StageBox>
  );
};

export default CourseStageBox;
